import type { PokerSundayMillion } from '@ps/web-martech-cms-types';

import { type WidgetEffectParams } from '@swf/core/store';
import { generateMTTEffects } from '@swf/poker';

import type { SundayMillionTab } from '../types';

import type { WidgetDispatch } from './types';

export async function changeTab(
  { tab }: { tab: SundayMillionTab },
  { dispatch, widget }: WidgetEffectParams<PokerSundayMillion>
) {
  const { setSelectedTab, subscribeToTournaments }: WidgetDispatch = dispatch[widget.uid];
  setSelectedTab({ selectedTab: tab });
  subscribeToTournaments({ setLoading: true });
}

export const effects = {
  ...generateMTTEffects<PokerSundayMillion>(),
  changeTab
};
